import { /*FormCheckbox, */ ChecksSvg } from "@components/index";

export const DefaultBusinessCard = ({
  uniqueId,
  name,
  onIgnoreMileage,
}: {
  uniqueId: string;
  name: string;
  onIgnoreMileage: (uniqueId: string) => void;
}) => (
  <div className="w-full max-w-[414px] rounded-lg border border-black-8">
    <div className="cursor-pointer rounded-lg bg-secondary-100">
      <div className="flex h-14 items-center gap-x-2 bg-white-8 px-6 text-button text-primary-200">
        <ChecksSvg />
        Default Business
      </div>
      <div className="flex h-[132px] flex-col justify-end rounded-b-lg p-6">
        <div className="font-light text-white-54">Business name</div>
        <div className="text-300 font-bold text-white-100">{name}</div>
      </div>
    </div>
    <div
      className="flex h-[52px] cursor-pointer items-center justify-between px-6 text-button text-secondary-100"
      onClick={() => onIgnoreMileage(uniqueId)}
    >
      {/* Ignore Mileage Log
      <FormCheckbox name={`ignoreMileage_${uniqueId}`} /> */}
    </div>
  </div>
);
